import { createApp } from 'vue';
import { Timer } from './libs/Timer';
import { AjaxRequest } from './libs/AjaxRequest';

const app = createApp({
	data() {
		return {
			showModal: false,
			loading: false,
			email: null,
			isInvalidEmail: null,
			sended: null,
		}
	},
	methods: {
		openModal() {
			this.showModal = true;

			this.$nextTick(() => this.$refs.email.focus());
		},
		closeModal() {
			this.showModal = false;
			this.email = null;
			this.sended = null;
		},
		async sendPublicationToEmail(event) {

			this.isInvalidEmail = null;
			if (!this.validEmail(this.email)) {
				console.log('email dont valid');
				this.isInvalidEmail = true;
				event.preventDefault();
				return;
			}
			const postId = this.$refs.postId.value;
			this.loading = true;

			try {
				await Timer.wait(800);
				console.log(`sharing post: ${postId}, with email: ${this.email}`);
				// throw Error('testing error');
				AjaxRequest.post({
					action: 'dlegal_share_publication',
					post_id: postId,
					email: this.email
				});

				this.loading = false;
				this.sended = true;
			} catch(err) {
				console.error(err);
				this.loading = false;
				this.sended = false;
			}


		},
		validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
	}
})

app.component("modal", {
	props: {loading: {type: Boolean, default: false}},
	template: "#modal-template",
})

app.mount('#app')
